// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1-imW","notes":"Notes_notes__1-vE6"};